import React, { forwardRef, Ref } from "react";
import { Date_normalizeDateString, Date_toDateString } from "../../common/dateUtils";

type DateInputProps = {
    inputId: string;
    defaultValue: Date;
    onBlur: (updatedDateString: string) => void;
    label: string | undefined;
    errorMessage?: string;
    readonly?: boolean;
    containerClassName?: string;
    minDate?: Date;
    maxDate?: Date;
};

const DateInput = forwardRef<HTMLInputElement, DateInputProps>(
    (
        {
            inputId,
            defaultValue,
            onBlur,
            label,
            errorMessage = "",
            readonly = false,
            containerClassName = "",
            minDate,
            maxDate
        },
        ref
    ) => {
        const errorMessageId = `${inputId}__error`;

        return (
            <div className={`form-group ${containerClassName}`}>
                <label className="fw-bold form-label" htmlFor={inputId}>
                    {label}
                </label>
                <input
                    id={inputId}
                    className={`form-control ${readonly ? "read-only-input" : ""}`}
                    type="date"
                    defaultValue={Date_toDateString(defaultValue)}
                    readOnly={readonly}
                    onBlur={(e) => onBlur(e.target.value)}
                    aria-errormessage={errorMessageId}
                    min={minDate ? Date_toDateString(minDate) : undefined}
                    max={maxDate ? Date_toDateString(maxDate) : undefined}
                    ref={ref}
                />
                <span id={errorMessageId} className="text-danger">
                    {errorMessage}
                </span>
            </div>
        );
    }
);

export default DateInput;
